import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const MAX_PIN = 4;

export default function LoginPage() {
  const { login, loading, error } = useAuth();
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [shake, setShake] = useState(false);

  const handleKey = useCallback(async (k: string) => {
    if (loading) return;
    if (k === '⌫') {
      setPin((p) => p.slice(0, -1));
      return;
    }
    const next = pin + k;
    setPin(next);
    if (next.length === MAX_PIN) {
      const ok = await login(next);
      if (ok) {
        navigate('/', { replace: true });
      } else {
        setShake(true);
        setTimeout(() => {
          setShake(false);
          setPin('');
        }, 600);
      }
    }
  }, [pin, login, loading, navigate]);

  const keys = ['1','2','3','4','5','6','7','8','9','','0','⌫'];

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-md">
      <img src="/tapnpay-brand.png" alt="TapNpay" className="mb-xl max-h-[60px] object-contain" />
      <h1 className="text-h2 font-bold text-on-surface-strong mb-sm">Bonjour</h1>
      <p className="text-sm text-on-surface-variant mb-xl">Code PIN</p>

      <div className={`mb-xl flex gap-4 ${shake ? 'animate-pin-shake' : ''}`}>
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={`h-3 w-3 rounded-full transition-colors duration-150 ${
              i < pin.length ? 'bg-primary' : 'bg-surface-container-high'
            }`}
          />
        ))}
      </div>

      <div className="grid grid-cols-3 gap-3 w-full max-w-[280px]">
        {keys.map((k, idx) => (
          <button
            key={idx}
            onClick={() => k && void handleKey(k)}
            disabled={!k || loading}
            className={`flex h-[64px] w-full items-center justify-center text-h2 font-bold text-on-surface bg-surface active:bg-surface-container-high transition-colors ${
              !k ? 'opacity-0 pointer-events-none' : ''
            }`}
            style={{ border: !k ? 'none' : '0.5px solid #e5e7eb' }}
            aria-label={k === '⌫' ? 'Supprimer' : k || undefined}
          >
            {k}
          </button>
        ))}
      </div>

      {error && (
        <p className="mt-md text-sm text-error font-medium">{error}</p>
      )}
      {loading && (
        <div className="mt-md h-5 w-5 animate-scanpay-spin rounded-full border-2 border-primary border-t-transparent" />
      )}
    </div>
  );
}
